/**
 * 处理传入的参数错误问题
 * @return 错误回调
 */
export function handleParamsError () {
  if (process.env.NODE_ENV !== 'production') {
    console.error('传入参数错误')
  }
  const error = {
    type: 'param'
  }
  return Promise.reject(error)
}

/**
 * 处理返回数据状态码错误
 * @param {Number} status 响应状态码
 */
export function handleStatusError (status) {
  if (process.env.NODE_ENV !== 'production') {
    console.error('status', status)
  }
  const error = {
    type: 'status',
    status
  }
  return Promise.reject(error)
}

/**
 * 处理返回数据错误
 * @param {String} state 请求失败状态码
 * @param {String} message 请求失败原因
 */
export function handleResponseError (state, message) {
  if (process.env.NODE_ENV !== 'production') {
    console.error('state', state, message)
  }
  const errorMap = {
    type: 'state',
    state,
    message
  }
  return Promise.reject(errorMap)
}

/**
 * 处理解析数据错误
 * @param {String} code 请求失败状态码
 * @param {String} message 请求失败原因
 */
export function handleDataError (code, message) {
  if (process.env.NODE_ENV !== 'production') {
    console.error('code', code, message)
  }
  const errorMap = {
    type: 'code',
    code,
    message
  }
  return Promise.reject(errorMap)
}



// WEBPACK FOOTER //
// ./src/plugins/request/error.js